export default __webpack_public_path__ + "static/hero-bg-a4fe31974bf1f8a5f29a67426cb3cfc7.svg";